import { render, staticRenderFns } from "./Action.vue?vue&type=template&id=05af880e&"
import script from "./Action.vue?vue&type=script&lang=ts&"
export * from "./Action.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports